import { render, staticRenderFns } from "./Rp.vue?vue&type=template&id=31edd0a1&scoped=true"
import script from "./Rp.vue?vue&type=script&lang=js"
export * from "./Rp.vue?vue&type=script&lang=js"
import style0 from "./Rp.vue?vue&type=style&index=0&id=31edd0a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31edd0a1",
  null
  
)

export default component.exports